import gql from 'graphql-tag';

const query = gql`
  query Integration {
    integration {
      feedback {
        url
      }
    }
  }
`;

export default query;
